module.exports = __webpack_public_path__ + "static/media/dad gif 1.0d20f9f5.gif";